var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.5,
    height: 36.5,
    rx: 4.75,
    fill: "#479573"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_2142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70001 30.0225V7.2275C6.70001 7.03455 6.77666 6.84951 6.91309 6.71308C7.04952 6.57665 7.23457 6.5 7.42751 6.5H21.5556C21.7484 6.50017 21.9334 6.57693 22.0697 6.7134L25.8866 10.5303C25.9545 10.5981 26.0083 10.6787 26.0449 10.7673C26.0815 10.8559 26.1002 10.951 26.1 11.0469V30.0225C26.1 30.118 26.0812 30.2126 26.0446 30.3009C26.0081 30.3892 25.9545 30.4694 25.8869 30.5369C25.8194 30.6045 25.7392 30.658 25.6509 30.6946C25.5626 30.7312 25.468 30.75 25.3725 30.75H7.42751C7.33198 30.75 7.23737 30.7312 7.14911 30.6946C7.06085 30.658 6.98065 30.6045 6.91309 30.5369C6.84554 30.4694 6.79195 30.3892 6.75539 30.3009C6.71883 30.2126 6.70001 30.118 6.70001 30.0225Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 6.5V10.6225C21.25 10.8154 21.3266 11.0005 21.4631 11.1369C21.5995 11.2733 21.7846 11.35 21.9775 11.35H26.1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.5,
    height: 36.5,
    rx: 4.75,
    stroke: "#24948C",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 27,
    fill: "white",
    transform: "translate(5.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile1);
export default __webpack_public_path__ + "static/media/file_1.2b0e2c56aecbda516abfa99b935cdde2.svg";
export { ForwardRef as ReactComponent };